import { WithTranslation } from 'react-i18next';
import { History } from '@dev/history';
import { RouteComponentProps } from 'react-router-dom';

import { BrowserInterface } from '@api/store';
import { SuppressionsState } from '@api/store/suppressions/types';
import { UploadState } from '@api/store/upload/types';
import { AccountState } from '@api/store/account/types';

type MatchParams = {
    search?: string;
    statuses?: string;
};

export interface AddSuppressionInterface extends WithTranslation, RouteComponentProps<MatchParams> {
    classes: any;
    history: History;
    browser: BrowserInterface;
    suppresions: SuppressionsState;
    upload: UploadState;
    account: AccountState;
}

export type StyledMobileType = {
    isMobile?: boolean;
};

export enum UploadType {
    Manual = 'manual',
    Upload = 'upload',
}
